import 'keen-slider/keen-slider.min.css'
import React, { useRef, useState, useEffect, useCallback } from 'react'

import CourseProgressCard from '../../../../components/CourseProgressCard'
import { BsArrowLeftShort, BsArrowRightShort } from 'react-icons/bs'
import { Container, ButtonWrapper } from './styles'
import { useKeenSlider } from 'keen-slider/react'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'

const MyContentsComponent: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0)
  const [pause, setPause] = useState(false)
  const courses = useSelector((state: RootState) => state.learningCourses.data)
  const timer = useRef<any>()
  const [sliderRef, slider] = useKeenSlider<HTMLDivElement>({
    mode: 'snap',
    loop: courses.length > Math.floor(window.innerWidth / 400),
    breakpoints: {
      '(max-width: 500px)': {
        slides: { perView: 1, spacing: 5 },
      },
      '(min-width: 1000px)': {
        slides: { perView: 4, spacing: 10 },
      },
    },
    slideChanged(s) {
      setCurrentSlide(s.track.details.rel)
    },
  })

  useEffect(() => {
    setPause(false)
    timer.current = setInterval(() => {
      if (!pause && slider.current.next.length > 0) {
        slider.current.next()
      }
    }, 5000)
    return () => {
      clearInterval(timer.current)
    }
  }, [pause, slider])

  const ArrowLeft = useCallback(({ disabled, onClick }) => {
    const disabeld = disabled ? ' arrow--disabled' : ''
    return (
      <button className={'arrow arrow--left' + disabeld} onClick={onClick}>
        <BsArrowLeftShort size={27} />
      </button>
    )
  }, [])

  const ArrowRight = useCallback(({ disabled, onClick }) => {
    const disabeld = disabled ? ' arrow--disabled' : ''
    return (
      <button className={'arrow arrow--right' + disabeld} onClick={onClick}>
        <BsArrowRightShort size={27} />
      </button>
    )
  }, [])

  return (
    <>
      {courses.length ? (
        <Container>
          <div className="upper-content">
            <h2 className="title">Meus conteúdos</h2>
            {courses.length > Math.floor(window.innerWidth / 400) && (
              <ButtonWrapper>
                <ArrowLeft
                  onClick={(e: any) => e.stopPropagation() || slider.current?.prev()}
                  disabled={currentSlide === 0}
                />
                <ArrowRight
                  onClick={(e: any) => e.stopPropagation() || slider.current?.next()}
                  disabled={
                    currentSlide && currentSlide === slider.current?.track.details.slides.length - 1
                  }
                />
              </ButtonWrapper>
            )}
          </div>

          <div ref={sliderRef} className="keen-slider">
            {courses.map((item, idx) => (
              <div className={`keen-slider__slide number-slide${idx}`} key={idx}>
                <CourseProgressCard
                  name={item?.name}
                  percentage={item.progress}
                  numberOfModules={item.modules}
                  icon={item.icon}
                  courseId={item.courseId}
                />
              </div>
            ))}
          </div>
        </Container>
      ) : (
        ''
      )}
    </>
  )
}

export default MyContentsComponent
